import { render, staticRenderFns } from "./FactoryInvoicesListPage.vue?vue&type=template&id=3792e0ad&scoped=true&"
import script from "./FactoryInvoicesListPage.vue?vue&type=script&lang=ts&"
export * from "./FactoryInvoicesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryInvoicesListPage.vue?vue&type=style&index=0&id=3792e0ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3792e0ad",
  null
  
)

export default component.exports